import moment from "moment";
import dashboard from "../assets/pojectImg/dashboard full view.png";
import analytics from "../assets/pojectImg/dashboard analytics.png";
import table from "../assets/pojectImg/admin data table.png";
import form from "../assets/pojectImg/admin form.png";
import hostelPaddyDefault from "../assets/pojectImg/default.png";
import hostelPaddyHomePage from "../assets/pojectImg/homePage.png";
import hostelPaddyhostelList from "../assets/pojectImg/hostels.png";
import hostelPaddyhostelDetails from "../assets/pojectImg/hostelDetails.png";
import userPage from "../assets/images/Screenshot 2022-09-26 at 11.43.12.png";
import taskManagerapp from "../assets/images/Screenshot 2023-08-29 at 11.26.45.png";
import taskManagerapp2 from "../assets/images/Screenshot 2023-08-29 at 11.25.26.png";
import taskManagerapp3 from "../assets/images/Screenshot 2023-08-29 at 11.23.56.png";
import taskManagerapp4 from "../assets/images/Screenshot 2023-08-29 at 11.23.21.png";
import seekool from "../assets/pojectImg/seekool.png";
import seekool2 from "../assets/pojectImg/seekool2.png";
import seekool3 from "../assets/pojectImg/seekool3.png";
import seekool4 from "../assets/pojectImg/seekool4.png";
import seekool5 from "../assets/pojectImg/seekool5.png";
import DematHome from "../assets/pojectImg/demat-home.png";
import DematOrder from "../assets/pojectImg/demat-orders.png";
import DematProduct from "../assets/pojectImg/demat-product.png";
import DematWallet from "../assets/pojectImg/demat-wallet.png";
import DematMobileHome from "../assets/pojectImg/demat-mobile-home.png";
import DematMobileOrder from "../assets/pojectImg/demat-mobile-order.png";
import DematMobileProduct from "../assets/pojectImg/demat-mobile-product.png";
import DematMobileWallet from "../assets/pojectImg/demat-mobile-wallet.png";

import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import InstagramIcon from "@material-ui/icons/Instagram";
import { getMobileOS } from "./helpers";

 const playStoreLink ='https://play.google.com/store/apps/details?id=com.demat.demat';
  const appStoreLink = 'https://apps.apple.com/ng/app/dematshop/id6745949274';

   const os = getMobileOS();

export const experience = [
  {
    title: "Senior Front-end Developer",
    url: "https://www.fxpal.co",
    institution: "FxPal",
    startDate: moment("2024-09-01T09:28:33.412Z").format("MMM-YYYY"),
    endDate: "Present",
    description:
      "Developing scalable and secured P2P exchange solution for FxPal, I developed the dashboard interfaces for displaying interactive visual insights of data, Create reusable components, Designed a secured Escrow system.",
  },
  {
    title: "Senior Software Engineer",
    url: "https://branddrive.co/",
    institution: "BrandDrive",
    startDate: moment("2022-01-01T09:28:33.412Z").format("MMM-YYYY"),
    endDate: moment("2024-08-01T09:28:33.412Z").format("MMM-YYYY"),
    description:
      "Designs and develops scalable, secure and innovative solutions for BrandDrive Web and mobile applications, Build dashboard interfaces for displaying interactive visual insights of data, Create reusable components and document, Use of clickup to assign and manage tasks, defects and backlog",
  },
  {
    title: "Lead front-end developer",
    url: "",
    institution: "Starhub's",
    startDate: moment("2023-03-01T09:28:33.412Z").format("MMM-YYYY"),
    endDate: moment("2023-07-15T09:28:33.412Z").format("MMM-YYYY"),
    description: `Led a team of talented front-end developers in the development of dynamic and high-performing web applications for Star Hub's digital platform.`,
  },
  {
    title: "Junior Front-end Developer",
    url: "https://heimdallinc.io/",
    institution: "Heimdall Technology",
    startDate: moment("2021-07-07T09:28:33.412Z").format("MMM-YYYY"),
    endDate: moment("2022-12-12T09:28:33.412Z").format("MMM-YYYY"),
    description:
      "At Heimdall, I was responsible for developing functional and appealing web-based applications based on usability, providing website maintenance and enhancements, using a combination of markup languages to write web pages, creating cascading style sheets (CSS) that are consistent across all browsers and platforms and staying up-to-date on emerging technologies.",
  },
];

export const education = [
  {
    title: "Bsc Chemistry",
    institution: "University of Abuja, Nigeria",
    startDate: moment("07-07-2013").format("MMM-YYYY"),
    endDate: moment("01-30-2018").format("MMM-YYYY"),
    description:
      "I graduated at the top 15% of my graduating class during my undergraduate studies at the University of Abuja, Nigeria where I gained strong operational research, problem solving and strong technical prowess.",
  },
];

export const myProjects = [
  {
    name: "Demat Shop Web",
    technologies: ["html", "css", "Typescript", "Next.js", "tailwind"],
    repo: "",
    url: "https://demat.shop/marketplace",
    appType: "web application",
    description: "Demat is a location-based marketplace for buying and selling items such as gadgets and home appliances. Payments are secured through an escrow system and released only after the buyer confirms item pickup, providing trust, transparency, and buyer protection.",
    images: [
      {
        id: 1,
        isDefault: true,
        imgUrl: DematHome,
      },
      {
        id: 2,
        isDefault: false,
        imgUrl: DematOrder,
      },
      {
        id: 3,
        isDefault: false,
        imgUrl: DematProduct,
      },
      {
        id: 4,
        isDefault: false,
        imgUrl: DematWallet,
      },
    ],
  },
  {
    name: "Demat Shop Mobile",
    technologies: ["Typescript", "React Native", "Expo"],
    repo: "",
    url: os === 'iOS' ? appStoreLink : playStoreLink,
    appType: "Mobile application",
    description: "Demat is a location-based marketplace for buying and selling items such as gadgets and home appliances. Payments are secured through an escrow system and released only after the buyer confirms item pickup, providing trust, transparency, and buyer protection.",
    images: [
      {
        id: 1,
        isDefault: true,
        imgUrl: DematMobileHome,
      },
      {
        id: 2,
        isDefault: false,
        imgUrl: DematMobileOrder,
      },
      {
        id: 3,
        isDefault: false,
        imgUrl: DematMobileProduct,
      },
      {
        id: 4,
        isDefault: false,
        imgUrl: DematMobileWallet,
      },
    ],
  },
  {
    name: "Hostel Paddy",
    technologies: ["html", "css", "Typescript", "Next.js", "tailwind"],
    repo: "",
    url: "https://www.hostelpaddy.com/home",
    description: 'Hostel Paddy connects individuals with verified house owners, making it easy to find safe, affordable, and convenient accommodation. The platform simplifies house hunting by matching users with apartments that fit their budget and location.',
    appType: "web application",
    images: [
      {
        id: 1,
        isDefault: true,
        imgUrl: hostelPaddyDefault,
      },
      {
        id: 2,
        isDefault: false,
        imgUrl: hostelPaddyHomePage,
      },
      {
        id: 3,
        isDefault: false,
        imgUrl: hostelPaddyhostelList,
      },
      {
        id: 4,
        isDefault: false,
        imgUrl: hostelPaddyhostelDetails,
      },
    ],
  },
  {
    name: "seekoool",
    technologies: ["html", "css", "Typescript", "Next.js", "tailwind"],
    repo: "",
    url: "https://www.seekoool.com/",
    appType: "web application",
    images: [
      {
        id: 1,
        isDefault: true,
        imgUrl: seekool2,
      },
      {
        id: 2,
        isDefault: false,
        imgUrl: seekool,
      },
      {
        id: 3,
        isDefault: false,
        imgUrl: seekool3,
      },
      {
        id: 4,
        isDefault: false,
        imgUrl: seekool4,
      },
      {
        id: 4,
        isDefault: false,
        imgUrl: seekool5,
      },
    ],
  },
  {
    name: "Hotel Reservations",
    technologies: ["html", "css", "React", "Ant Design"],
    repo: "",
    url: "",
    appType: "web application",
    images: [
      {
        id: 1,
        isDefault: true,
        imgUrl: userPage,
      },
      {
        id: 2,
        isDefault: false,
        imgUrl: userPage,
      },
      {
        id: 3,
        isDefault: false,
        imgUrl: userPage,
      },
    ],
  },
  {
    name: "Task Manager",
    technologies: [
      "html",
      "css",
      "React",
      "Typescript",
      "Redux",
      "React Redux",
    ],
    repo: "https://github.com/promzzy/taskManager.git",
    url: "https://task-manager-software.netlify.app/",
    appType: "web application",
    images: [
      {
        id: 1,
        isDefault: true,
        imgUrl: taskManagerapp4,
      },
      {
        id: 2,
        isDefault: false,
        imgUrl: taskManagerapp2,
      },
      {
        id: 4,
        isDefault: false,
        imgUrl: taskManagerapp3,
      },
      {
        id: 5,
        isDefault: false,
        imgUrl: taskManagerapp,
      },
    ],
  },
  {
    name: "Admin Dashboard",
    technologies: ["html", "css", "Javascript"],
    repo: "",
    url: "",
    appType: "web application",
    images: [
      {
        id: 1,
        isDefault: true,
        imgUrl: dashboard,
      },
      {
        id: 2,
        isDefault: false,
        imgUrl: analytics,
      },
      {
        id: 3,
        isDefault: false,
        imgUrl: table,
      },
      {
        id: 4,
        isDefault: false,
        imgUrl: form,
      },
    ],
  },
];

export const socialLinks = [
  {
    title: "github",
    icon: GitHubIcon,
    url: "https://github.com/promzzy",
  },
  {
    title: "Twitter",
    icon: TwitterIcon,
    url: "https://twitter.com/PromzzyTech",
  },
  {
    title: "linkedin",
    icon: LinkedInIcon,
    url: "https://www.linkedin.com/in/promise-stephen-78807813b/",
  },
  {
    title: "instagram",
    icon: InstagramIcon,
    url: "https://www.instagram.com/promzzytech_/",
  },
];

export const RESUME_LINK =
  "https://drive.google.com/file/d/1u-kAqHld14YtxBT2fOAGiJZMs0cQiHDR/view?usp=sharing";
